import React from "react";
import styles from "./IssueCreditsSuccess.module.scss";
import LayoutHeader from "@features/common/header/layoutHeader/LayoutHeader";
import { Button } from "@mui/material";
import { SuccessPageTickIcon, SuccessSubmitLogo } from "customIcons";
import { useNavigate } from "react-router-dom";
import { PAGE_URLS } from "@constants/common";
import { useAppSelector } from "@redux/hooks";
import {
  selectDashboardData,
  selectProfileData,
} from "@redux/slices/CommonSlice";

const IssueCreditsSuccess = () => {
  /* --------------------------------------------------------------------------
   * Hooks
   * -------------------------------------------------------------------------- */
  const navigate = useNavigate();

  /* --------------------------------------------------------------------------
   * Handlers
   * -------------------------------------------------------------------------- */
  /**
   * Redirects user to issue credits page to create a new order
   */
  const redirectIssueCredits = () => {
    navigate(PAGE_URLS.ISSUE_CREDITS);
  };

  const dashboardData = useAppSelector(selectDashboardData);
  const profileData = useAppSelector(selectProfileData);

  const redirectToOrderHistory = () => {
    navigate(PAGE_URLS.CREDIT_REPORTS);
  };

  /* --------------------------------------------------------------------------
   * Render
   * -------------------------------------------------------------------------- */
  return (
    <div className={styles["page-container"]}>
      {/* Header - Shows order completion status and total amount */}
      <LayoutHeader
        headerTitle="Order Completed"
        currency={dashboardData?.currency}
        amount={dashboardData?.amount}
      />

      {/* Success Card */}
      <div className={styles["page-container__content-card"]}>
        {/* Success Logo */}
        <div className={styles["page-container__content-card__logo"]}>
          <SuccessSubmitLogo />
        </div>

        {/* Success Title */}
        <div className={styles["page-container__content-card__title"]}>
          Thank you for placing credit order
        </div>

        {/* Confirmation Message with Icon */}
        <div className={styles["page-container__content-card__description"]}>
          <SuccessPageTickIcon />
          <p>
            You will receive a confirmation email once the credits are processed
          </p>
        </div>

        {/* Action Buttons */}
        <div className={styles["page-container__content-card__actions"]}>
          {/* View Order History Button */}
          {profileData?.enabled_navigation?.credit_reports && (
            <Button
              variant="outlined"
              className="create-promo-cancel-button"
              onClick={redirectToOrderHistory}
            >
              View Order History
            </Button>
          )}

          {/* Issue New Credits Button */}
          <Button
            variant="contained"
            className="create-promo-submit-button"
            onClick={redirectIssueCredits}
          >
            Issue New Credits
          </Button>
        </div>
      </div>
    </div>
  );
};

export default IssueCreditsSuccess;
